export const config = {
    VITE_GOOGLE_CLIENT_ID: process.env.VITE_GOOGLE_CLIENT_ID,
    VITE_GOOGLE_CLIENT_SECRET: process.env.VITE_GOOGLE_CLIENT_SECRET,
    VITE_REDIRECT_URI: process.env.VITE_REDIRECT_URI || 'https://dev-creative-workspace.techo.camp',
    VITE_BACKEND_URL: process.env.VITE_BACKEND_URL || 'http://localhost:3000',
    VITE_DOMAIN_NAME_URL: process.env.VITE_DOMAIN_NAME_URL || 'https://dev-proposals-ai.techo.camp',
    VITE_ASSISTANT_NAME: process.env.VITE_ASSISTANT_NAME || 'cwchatorchestrator',
    VITE_PROJECT_CREATION_ASSISTANT_NAME: process.env.VITE_PROJECT_CREATION_ASSISTANT_NAME || 'cwprojectcreation',
    VITE_WEBSOCKET_URL: process.env.VITE_WEBSOCKET_URL || 'wss://dev-proposals-ai.techo.camp/graphql',
    VITE_CW_BACKEND_URL: process.env.VITE_CW_BACKEND_URL || 'https://dev-creative-workspace.techo.camp',
};
